
















































































































































































































































































































































































































































































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import SideBar from "@/employee/components/healthcareExpenseV2/SideBar.vue";
import Widget from "@/shared/components/Widget.vue";
import CategoryPill from "@/shared/components/CategoryPill.vue";
import {
  FetchState,
  HsabExpenseCategory,
  HsabExpenseCategoryDisplay,
  HsabExpenseFormSubmitMethod,
  HsabExpenseOriginator,
  HsabExpenseRequest,
  HsabExpenseResponse,
  HsabPayee,
  HsabSsoDestination,
  HsabSubmitExpenseError,
  ManuallyMarkedAsPaidStatus,
  WexExpenseAccountType,
} from "@/shared/types";
import EvidenceUpload from "@/shared/components/expenseV2/EvidenceUpload.vue";
import DenialReason from "@/employee/components/landing-pages/hsabank/expense/HsabWexClaimDenial.vue";
import Button from "@/shared/components/ui/Button.vue";
import { useExpenseV2Store } from "@/employee/store/expenseV2";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useUserStore } from "@/shared/store/user";
import { useThemeStore } from "@/shared/store/theme";
import { formatCurrency } from "@/shared/currency.js";
import PayeeSelector from "@/employer/components/payees/PayeeSelector.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import moment from "moment";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import _ from "lodash";
import { useHsabExpenseEvidenceStore } from "@/employee/store/hsabExpenseEvidence";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useConsumerBankAccountStore } from "@/employee/store/consumerBankAccount";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";

@Component({
  computed: {
    HsabSsoDestination () {
      return HsabSsoDestination;
    },
    ManuallyMarkedAsPaidStatus () {
      return ManuallyMarkedAsPaidStatus;
    },
    FetchState () {
      return FetchState;
    }
  },
  components: {
    SsoDeepLink,
    Button,
    Checkbox,
    GenericLoadingSpinner,
    EvidenceUpload,
    DenialReason,
    CategoryPill,
    HsabExpenseEvidence,
    PayeeSelector,
    Widget,
    SideBar
  }
})
export default class HsabExpenseForm extends Vue {
  formatCurrency = formatCurrency;

  contactInformationStore = useContactInfoStore();
  themeStore = useThemeStore();
  expenseStore = useExpenseV2Store();
  userStore = useUserStore();
  contactInfoStore = useContactInfoStore();
  hsabExpenseStore = useHsabExpenseStore();
  hsabExpenseEvidenceStore = useHsabExpenseEvidenceStore();
  hsabAccountsStore = useHsabAccountsStore();
  consumerBankAccountStore = useConsumerBankAccountStore();

  @Prop()
  expense: HsabExpenseResponse;

  @Prop()
  readonly: boolean;

  @Prop()
  hideExpenseHeader: boolean;

  expenseForm: HsabExpenseRequest = { ...this.newExpense };
  showDeleteConfirmationModal = false;
  showSubmitConfirmationModal = false;
  isSaving = false;
  isUploadingFilesToSubmittedExpense = false;
  isTravelCostReimbursementEnabled = false;
  isReimbursing = false;
  transactionType = 0;
  disableSaveButtons = false;
  agreedToTerms = false;
  expenseSaving = false;
  categoryPills: HsabExpenseCategoryDisplay[] = this.hsabExpenseStore.getCategoriesForUsersPlans;
  currentlySelectedCategory: HsabExpenseCategoryDisplay = null;
  formSubmitMethod: HsabExpenseFormSubmitMethod = HsabExpenseFormSubmitMethod.save;

  @Watch("expense")
  syncPropWithForm () {
    if (this.expense) {
      this.expenseForm = { ...this.expenseForm, ...this.expense };
      if (this.expense.numberOfMiles) {
        this.isTravelCostReimbursementEnabled = true;
      }
    } else {
      this.expenseForm = { ...this.newExpense };
      this.isTravelCostReimbursementEnabled = false;
    }
  }


  @Watch("expenseForm.isPayToPayee")
  updateContactInfo () {
    if (!this.expenseForm.isPayToPayee) {
      this.contactInformationStore.getContactInformation();
    }
  }

  created () {
    if (!this.expenseForm.isPayToPayee) {
      this.contactInformationStore.getContactInformation();
    }
  }

  beforeMount () {
    this.$validator.extend("required_to_save", this.validateRequiredToSave, { computesRequired: true });
    this.$validator.extend("required_to_submit", this.validateRequiredToSubmit, { computesRequired: true });
  }

  mounted () {
    this.syncPropWithForm();
    this.categoryPills = this.hsabExpenseStore.getCategoriesForUsersPlans;
    this.hsabExpenseStore.loadExpenseCategories().then(
        _ => {
          this.setExpenseCategoryOnMounted();
        }
    );
    this.consumerBankAccountStore.loadBankAccounts();
  }

  get showExpenseTypeDropdown () {
    return !this.readonly
        && !this.hsabExpenseStore.isCategoryDataLoading
        && this.hsabExpenseStore.isCategoryDataLoaded
        && !this.isHsaOnly
        && (this.currentlySelectedCategory
            && this.currentlySelectedCategory.showTypeSelector);
  }

  get showExpenseSubtypeDropdown () {
    return !this.isHsaOnly && this.hsabExpenseStore.isCategoryDataLoaded && !this.isStringNullOrEmpty(this.expenseForm.expenseType);

  }

  get hasExternalId () {
    return this.expense && !this.isStringNullOrEmpty(this.expense.externalExpenseId);
  }

  get mailingAddress () {
    if (!this.contactInfoStore
        || !this.contactInfoStore.contactInformation
        || !this.contactInfoStore.contactInformation.mailingAddress) {
      return null;
    }

    return this.contactInfoStore.contactInformation.mailingAddress;
  }

  get showManuallyPaidOption () {
    return this.expense && this.expense.originator === HsabExpenseOriginator.CarrierClaim;
  }

  get newExpense (): HsabExpenseRequest {
    return {
      hsabExpenseId: null,
      expenseName: "",
      providerName: "",
      amount: 0,
      comment: "",
      dateOfService: this.today,
      isPayToPayee: false,
      payeeName: "",
      payeeMemberNumber: "",
      payeeAddress1: "",
      payeeAddress2: "",
      payeeCity: "",
      payeeStateCode: "",
      payeeZipCode: "",
      expenseCategory: HsabExpenseCategory.Medical,
      expenseType: "",
      expenseSubType: "",
      numberOfMiles: 0,
      mileageDollarValue: null,
      stagedFilesForUpload: [],
      manuallyMarkedAsPaidStatus: ManuallyMarkedAsPaidStatus.NotMarkedAsPaid
    };
  }

  get uploadFileCount () {
    let count = 0;
    if (this.expense && this.expense.expenseEvidence) {
      count += this.expense.expenseEvidence.length;
    }
    if (this.expenseForm.stagedFilesForUpload) {
      count += this.expenseForm.stagedFilesForUpload.length;
    }
    return count;
  }

  get canDelete () {
    return !this.readonly &&
        this.expense &&
        this.expense.originator === HsabExpenseOriginator.Consumer;
  }

  get recipientDisplay () {
    return this.userStore.displayName;
  }

  get isMedicalCategorySelected () {
    return this.currentlySelectedCategory
        && this.currentlySelectedCategory.external === WexExpenseAccountType.Medical;
  }

  get isFormSubmitMethodSaveAndSubmit () {
    return this.formSubmitMethod === HsabExpenseFormSubmitMethod.saveAndSubmit;
  }

  get isFormSubmitMethodSave () {
    return this.formSubmitMethod === HsabExpenseFormSubmitMethod.save;
  }

  get isAddingReceiptsAllowed () {
    if (!this.expense) {
      // creating new expense
      return true;
    }

    const claim = this.expense.reimbursement;
    if (!claim) {
      // available expense (unsubmitted)
      return !this.readonly;
    }

    return this.hsabExpenseStore.isAddingClaimReceiptsAllowed(this.expense.reimbursement);
  }

  get eligibleAmountValidator () {
    return {
      required: true,
      decimal: 2,
      min_value_usd: 0.01
    };
  }

  get showCategoryInReview () {
    return this.expenseForm.expenseCategory !== undefined
        && this.expenseForm.expenseCategory !== null
        && this.expenseForm.expenseCategory !== HsabExpenseCategory.Unknown;
  }

  get showExpenseTypeInReview () {
    return this.expenseForm.expenseType !== undefined
        && this.expenseForm.expenseType !== null
        && this.expenseForm.expenseType !== "";
  }

  get showExpenseSubTypeInReview () {
    return this.expenseForm.expenseSubType !== undefined
        && this.expenseForm.expenseSubType !== null
        && this.expenseForm.expenseSubType !== "";
  }

  get hasDenialReasons (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.denialReasons
        && this.expense.reimbursement.denialReasons.length > 0;
  }

  get allFilesForReview () {
    let results = _.map(this.expenseForm.stagedFilesForUpload, x => x.name);

    if (this.expense && this.expense.expenseEvidence) {
      const existingEvidence = this.expense.expenseEvidence;
      const existingFileNames = _.map(existingEvidence, e => e.fileName);
      results = results.concat(existingFileNames);
    }

    return results;
  }

  get formattedServiceDate () {
    return moment(this.expenseForm.dateOfService).format("MMMM DD, YYYY");
  }

  get sendPaymentTo () {
    if (this.expenseForm.isPayToPayee) {
      return this.expenseForm.payeeName;
    } else {
      return this.recipientDisplay;
    }
  }

  get isAddingAdditionalEvidence () {
    return this.expenseForm && this.expenseForm.stagedFilesForUpload.length > 0;
  }

  get isExpenseSubmitted (): boolean {
    return this.expense && this.expense.isSubmitted;
  }

  get isExpenseSubmittedToHsa (): boolean {
    return this.expense &&
        this.expense.isSubmitted &&
        this.expense.reimbursement &&
        this.expense.reimbursement.isHsaReimbursement;
  }

  get expenseTypesForSelectedCategory () {
    return this.hsabExpenseStore.getExpenseTypesAndSubtypesByCategory(this.expenseForm.expenseCategory);
  }

  get subTypesForCurrentExpenseType () {
    if (this.isStringNullOrEmpty(this.expenseForm.expenseCategory)
        || this.isStringNullOrEmpty(this.expenseForm.expenseType)) {
      return [];
    }
    const expenseType = this.hsabExpenseStore.getExpenseTypeByCategoryAndType(
        this.expenseForm.expenseCategory,
        this.expenseForm.expenseType);
    if (!expenseType) {
      return [];
    }
    return expenseType.expenseSubTypes;
  }

  get expenseTypeDropdownLabel () {
    return this.expenseForm.expenseType ? this.expenseForm.expenseType : "Select a type";
  }

  get subTypeDropdownLabel () {
    return this.expenseForm.expenseSubType ? this.expenseForm.expenseSubType : "Select a sub-type";
  }

  get isHsaOnly () {
    const userHasHsa = this.hsabAccountsStore.userHasHsaAccount;
    const userHasNotional = this.hsabAccountsStore.userHasActiveNotionalAccounts;
    return (!userHasNotional && userHasHsa);
  }

  get isNotionalOnly () {
    const userHasHsa = this.hsabAccountsStore.userHasHsaAccount;
    const userHasNotional = this.hsabAccountsStore.userHasActiveNotionalAccounts;
    return (userHasNotional && !userHasHsa);
  }

  get today (): string {
    return moment().format("MM/DD/YYYY");
  }

  get hasLinkedBankAccount () {
    return this.consumerBankAccountStore.getDirectDepositAccount
        && this.consumerBankAccountStore.getDirectDepositAccount.bankAccountKey
        && !this.isStringNullOrEmpty(this.consumerBankAccountStore.getDirectDepositAccount.bankAccountKey.accountLastFour);
  }

  get bankAccountDisplay (): string {
    if (this.hasLinkedBankAccount) {
      return this.MaskBankAccountNumber(this.consumerBankAccountStore.getDirectDepositAccount.bankAccountKey.accountLastFour);
    }
    return "No linked bank account.";
  }

  MaskBankAccountNumber (acctLastFour): string {
    return "*****" + acctLastFour;
  }

  get disableSubmitButton () {
    return this.isSaving
        || this.disableSaveButtons
        || (this.isNotionalOnly && this.uploadFileCount === 0)
        || !this.hsabAccountsStore.userHasAnyActiveAccount
        || (this.expense
            && this.expense.originator === HsabExpenseOriginator.CarrierClaim
            && this.expenseForm.manuallyMarkedAsPaidStatus !== ManuallyMarkedAsPaidStatus.NotMarkedAsPaid);
  }

  get submitButtonTooltip () {
    if (this.expense
        && this.expense.originator === HsabExpenseOriginator.CarrierClaim
        && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.MarkedAsPaid) {
      return "Cannot submit an expense that has been marked as paid";
    } else if (this.expense
        && this.expense.originator === HsabExpenseOriginator.CarrierClaim
        && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.Unknown) {
      return "Please select if this claim has already been paid or not";
    } else if (this.isNotionalOnly && this.uploadFileCount === 0) {
      return "Cannot submit an expense without receipts attached";
    }

    return "";

  }

  setExpenseCategoryOnMounted () {
    if (this.categoryPills.length > 0 && this.expense && this.isStringNullOrEmpty(this.expense.expenseCategory)) {
      // existing expense w/out a category selected
      this.onExpenseCategorySelected(this.categoryPills[0]);
    } else if (this.categoryPills.length > 0 && this.expense && !this.isStringNullOrEmpty(this.expense.expenseCategory)) {
      // existing expense with a category selected
      this.onExpenseCategorySelected(this.categoryPills.find(x => x.category === this.expense.expenseCategory));
      this.expenseForm.expenseType = this.expense.expenseType;
      this.expenseForm.expenseSubType = this.expense.expenseSubType;
    } else if (this.categoryPills.length > 0 && !this.expense) {
      // new expense form
      this.onExpenseCategorySelected(this.categoryPills[0]);
    }
  }

  getExpensePayeeData (): HsabPayee {
    if (this.expenseForm.hsabExpenseId && this.expenseForm.hsabExpenseId > 0 && this.expenseForm.isPayToPayee) {
      return {
        payeeName: this.expenseForm.payeeName,
        memberAccountNumber: this.expenseForm.payeeMemberNumber,
        address1: this.expenseForm.payeeAddress1,
        address2: this.expenseForm.payeeAddress2,
        city: this.expenseForm.payeeCity,
        stateCode: this.expenseForm.payeeStateCode,
        zip: this.expenseForm.payeeZipCode,
      };
    } else {
      return null;
    }
  }

  handleCancelAction () {
    this.expenseForm = { ...this.expense, stagedFilesForUpload: [] };
    this.handleCloseAction();
  }

  handleCloseAction () {
    this.$emit("close-action");
  }

  closeDeleteConfirmationModal () {
    this.showDeleteConfirmationModal = false;
  }

  confirmDelete () {
    this.hsabExpenseStore.deleteExpense(this.expense.hsabExpenseId);
    this.closeDeleteConfirmationModal();
    this.handleCloseAction();
  }

  confirmSubmit () {
    this.expenseSaving = true;

    this.hsabExpenseStore.CreateOrUpdateExpenseAndSubmitForReimbursement(this.expenseForm)
        .then(_ => {
          this.agreedToTerms = false;
          this.showSubmitConfirmationModal = false;
          this.expenseSaving = false;
          this.handleCloseAction();
        })
        .catch(failedStep => {
          switch (failedStep) {
            case HsabSubmitExpenseError.CreateExpense:
              break;
            case HsabSubmitExpenseError.UploadFiles:
            case HsabSubmitExpenseError.SubmitForReimbursement:
              this.handleCloseAction();
              this.hsabExpenseStore.reloadPage();
              break;
          }

          this.expenseSaving = false;
        });
  }

  handleReimburseAction () {
    this.formSubmitMethod = HsabExpenseFormSubmitMethod.saveAndSubmit;
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
      if (!valid) {
        return;
      }

      this.showSubmitConfirmationModal = true;
    });
  }

  addFiles (files) {
    this.expenseForm.stagedFilesForUpload = files;
  }

  handleSaveAction () {
    this.formSubmitMethod = HsabExpenseFormSubmitMethod.save;
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
      if (!valid) {
        return;
      }
      this.isSaving = true;
      if (!this.expenseForm.isPayToPayee) {
        this.clearPayeeFormData();
      }
      this.hsabExpenseStore.saveExpense(this.expenseForm)
          .then(() => {
            this.isSaving = false;
            this.handleCloseAction();
            this.hsabExpenseStore.loadPageAvailableExpenses({ page: 1, force: true });
          });

    });
  }

  handleAddFilesAfterSubmitted () {
    if (!this.expense || !this.expenseForm || !this.expenseForm.stagedFilesForUpload) {
      return;
    }

    this.isUploadingFilesToSubmittedExpense = true;
    this.hsabExpenseEvidenceStore.UploadFilesToSubmittedHsabExpense(
            this.expense.hsabExpenseId,
            this.expenseForm.stagedFilesForUpload,
            this.expense.reimbursement.isHsaReimbursement)
        .then(_ => {
          this.isUploadingFilesToSubmittedExpense = false;
          this.hsabExpenseStore.loadPageSubmittedExpenses({
            page: this.hsabExpenseStore.submittedExpenses.page,
            force: true
          });
          this.handleCloseAction();
        })
        .catch(err => {
          this.isUploadingFilesToSubmittedExpense = false;
        });
  }

  clearPayeeFormData () {
    this.expenseForm.payeeName = "";
    this.expenseForm.payeeMemberNumber = "";
    this.expenseForm.payeeAddress1 = "";
    this.expenseForm.payeeAddress2 = "";
    this.expenseForm.payeeCity = "";
    this.expenseForm.payeeStateCode = "";
    this.expenseForm.payeeZipCode = "";
  }

  onPayeeSelected (payee: HsabPayee) {
    if (payee) {
      this.expenseForm.payeeName = payee.payeeName;
      this.expenseForm.payeeMemberNumber = payee.memberAccountNumber;
      this.expenseForm.payeeAddress1 = payee.address1;
      this.expenseForm.payeeAddress2 = payee.address2;
      this.expenseForm.payeeCity = payee.city;
      this.expenseForm.payeeStateCode = payee.stateCode;
      this.expenseForm.payeeZipCode = payee.zip;
    } else {
      this.clearPayeeFormData();
    }
  }

  onPayeeEditStateChanged (isEditing: boolean) {
    this.disableSaveButtons = isEditing;
  }

  readonly payTypes = [
    { text: "Reimburse Myself", value: false },
    { text: "Pay Someone Else", value: true }
  ];

  onTravelReimbursementChanged () {
    this.$validator.errors.remove("Number of miles");
    this.$validator.errors.remove("Mileage dollar value");
  }

  onTravelCostReimbursementEnabledChanged (val) {
    if (val === false) {
      this.expenseForm.numberOfMiles = undefined;
    }
  }

  onExpenseCategorySelected (categoryDisplay) {
    this.currentlySelectedCategory = categoryDisplay;
    this.expenseForm.expenseCategory = categoryDisplay.category;
    this.expenseForm.expenseType = null;
    this.expenseForm.expenseSubType = null;
    if (categoryDisplay.external !== WexExpenseAccountType.Medical) {
      this.isTravelCostReimbursementEnabled = false;
      this.expenseForm.numberOfMiles = null;
    }

    if (!this.isHsaOnly) {
      const expenseTypes = this.expenseTypesForSelectedCategory;

      if (expenseTypes.length === 1) {
        this.onExpenseTypeSelected(expenseTypes[0].expenseType);
      } else if (categoryDisplay.defaultTypeWhenSelected) {
        const shouldSelect = expenseTypes.find(x => x.expenseType === categoryDisplay.defaultTypeWhenSelected);
        if (shouldSelect) {
          this.onExpenseTypeSelected(shouldSelect.expenseType);
        }
      }
    }
  }

  onExpenseTypeSelected (expenseType) {
    Vue.set(this.expenseForm, "expenseType", expenseType);

    const subTypes = this.subTypesForCurrentExpenseType;
    if (subTypes.length === 1) {
      this.onExpenseSubTypeSelected(subTypes[0].subTypeName);
    } else {
      this.onExpenseSubTypeSelected(null);
    }
  }

  onExpenseSubTypeSelected (subType) {
    Vue.set(this.expenseForm, "expenseSubType", subType);
  }

  isNullEmptyOrZero (val) {
    return val === undefined || val === null || val === "" || val === 0;
  }

  validateRequiredToSave (x) {
    return {
      valid: this.isFormSubmitMethodSave ? (x !== undefined && x !== null && x !== "") : true,
      data: {
        required: this.isFormSubmitMethodSave
      }
    };
  }

  validateRequiredToSubmit (x) {
    return {
      valid: this.isFormSubmitMethodSaveAndSubmit ? (x !== undefined && x !== null && x !== "") : true,
      data: {
        required: this.isFormSubmitMethodSaveAndSubmit
      }
    };
  }

  isStringNullOrEmpty (str) {
    return str === undefined || str === null || str === "";
  }
}
